import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

import OffersIcon from "react-icons/lib/fa/newspaper-o";
import ApplicationsIcon from "react-icons/lib/fa/file-text-o";
import LogoutIcon from "react-icons/lib/fa/sign-out";
import CogIcon from "react-icons/lib/fa/cog";

import routes from "../../routes";
import colors from "../../colors";

import { sidebarClose } from "../../app/actions";
import { logout } from "../../auth/actions";

class MenuItem extends Component {
  render() {
    const { to, children, Icon, sidebarClose, onClick } = this.props;

    return (
      <MenuItemStyled to={to || "#"} onClick={onClick || sidebarClose}>
        <Icon size={15} color="#536c79" />
        <Text>{children}</Text>
      </MenuItemStyled>
    );
  }
}

MenuItem = connect(null, { sidebarClose })(MenuItem);

const MenuItemStyled = styled(NavLink)`
  display: block;
  padding: 5px 30px;
  text-decoration: none;
  font-weight: 400;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  color: #646464;
  &:hover {
    background: #f0f0f0;
    color: #646464;
    text-decoration: none;
  }
  &.active {
    color: ${colors.secondary};
    svg {
      color: ${colors.secondary} !important;
    }
  }
`;

class Menu extends Component {
  render() {
    const { logout } = this.props;
    return (
      <Wrapper>
        <MenuTitle>MENU</MenuTitle>
        <MenuItem to={routes.offers} Icon={OffersIcon}>
          Oferty
        </MenuItem>
        <MenuItem to={routes.applications} Icon={ApplicationsIcon}>
          Aplikacje
        </MenuItem>
        <MenuItem to={routes.settings} Icon={CogIcon}>
          Dane agencji
        </MenuItem>
        <MenuItem onClick={logout} Icon={LogoutIcon}>
          Wyloguj się
        </MenuItem>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  border-right: 1px solid #e3e3e3;
  height: 100%;
  user-select: none;
`;
const MenuTitle = styled.div`
  display: flex;
  align-items: center;
  height: 55px;
  padding: 0px 30px;
  color: #b0b0b0;
  font-size: 12px;
  font-weight: 500;
`;

const Text = styled.span`margin-left: 10px;`;

Menu = connect(null, { logout })(Menu);
export default Menu;



// WEBPACK FOOTER //
// ./src/components/Site/Menu.js